import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import CheckBoxListInput from "../../../formFields/CheckBoxListInput";
import { WithHeader } from "../../../common/WithHeader";
import { setCategories } from "../../../../store/actions/nearByActions";
import Roles from "./Roles";
import CheckBoxListInputSingleSelect from "../../../formFields/CheckBoxListInputSingleSelect";

const Category = () => {
  const dispatch = useDispatch();

  const language = useSelector((state) => state.nearBy.language);
  const selectedSpecies =
    useSelector((state) => state?.nearBy?.categories) || [];

  const handleToggle = (id) => {
    console.log("id", id);
    dispatch(setCategories(id)); // Dispatch the updated string
  };

  return (
    <CheckBoxListInputSingleSelect
      items={Roles?.[language] ?? []}
      selectedItems={selectedSpecies ?? []}
      onDeleteItem={() => {}}
      onToggleItem={handleToggle}
      getItemTitle={(item) => item.label}
      maxSelectionLimit={5}
      allowAddItem={false}
      allowDelete={false}
    />
  );
};

export default WithHeader(Category, "Category *");
